import React, { useStat, useEffect, useRef, useState } from 'react';
import { connect, useSelector, useDispatch} from "react-redux";
import "../../../../../../../css/workspace.css";
import {
    Button,
    Tooltip,
    Table,
    Tag,
    Space,
    Modal,
    Input
  } from "antd";
import {
  DeleteOutlined,
  EditOutlined
} from "@ant-design/icons";
import { notify } from "../../../../../../../components/Snack";
import {
  getTrainedDataV2,
  deleteTrainedDataV2,
  sendInputAnswerV2,
} from "../../../../../../../redux/actions/collectionsV2";
import { useHistory, useLocation } from "react-router-dom";

const TrainedData = () => {

    const [_trainedDataList, _setTrainedDataList] = useState([]);
    const [loading, setLoading] = useState(false);

    const trainedDataList = useSelector(
        (state) => state.collectionReducer.trainedData
    );

    const userDetails = useSelector(
        (state) => state?.organizationReducer?.currentOrganization
      );
    const isAdmin = userDetails?.role_id === "2" ? true : false;
    const viewOnly = userDetails?.role_id === "1" ? true : false;

  const queryParams = useLocation().search;
  const collectionName =  new URLSearchParams(queryParams).get("name");
  const dispatch = useDispatch();
  const groupPlan = useSelector((state) => state.userReducer.groupPlan);
    let planType;
    if (groupPlan?.planId == 4) {
        planType = "team";
    } else if (groupPlan?.planId == 5) {
        planType = "business";
    } else {
        planType = "pro";
    }

    const { TextArea } = Input;
    const [isAnswerNew, setIsAnswerNew] = useState(false);
    const [newAnswerText, setNewAnswerText] = useState("");
    const [isAnswerOld, setIsAnswerOld] = useState(false);
    const [oldAnswerText, setOldAnswerText] = useState("");
    const [editAnswerOldText, setEditAnswerOldText] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editQuestionID, setEditQuestionID] = useState("");
    const [editQuestionText, setEditQuestionText] = useState("");
    const [editAnswerValue, setEditAnswerValue] = useState("");

    const handleOk = () => {
      setIsModalOpen(false);
      setLoading(true);
      
        dispatch(
          deleteTrainedDataV2(
            collectionName,
            editQuestionID,
            editQuestionText,
            planType
          )
        ).then(() => {
          sendInputAnswerV2(
            collectionName,
            editQuestionID,
            editQuestionText,
            editAnswerOldText,
            editAnswerValue,
            planType
          ).then(() => {
            dispatch(notify("success", "Updated answer successfully"));
            dispatch(getTrainedDataV2(collectionName));
            setLoading(false);
          });
        });
      
    };
  
    const handleCancel = () => {
      setEditAnswerValue("");
      setIsModalOpen(false);
    };
  
    const showModalOldAnswer = (text) => {
      setIsAnswerOld(true);
      setOldAnswerText(text);
    };
    const showModalNewAnswer = (text) => {
      setIsAnswerNew(true);
      setNewAnswerText(text);
    };
    const handleOkOld = () => {
      setIsAnswerOld(false);
    };
    const handleCancelOld = () => {
      setIsAnswerOld(false);
    };
    const handleOkNew = () => {
      setIsAnswerNew(false);
    };
    const handleCancelNew = () => {
      setIsAnswerNew(false);
    };
    const showModalEditAnswer = (record) => {
      setIsModalOpen(true);
      setEditQuestionID(record.id);
      setEditQuestionText(record.question);
      setEditAnswerOldText(record.new_answer);
      setEditAnswerValue(record.new_answer);
    };

    useEffect(() => {
        _setTrainedDataList(trainedDataList);
    }, [trainedDataList]);
    
    const deleteUploadedAnswer = async (record) => {
      setLoading(true);
        dispatch(
          deleteTrainedDataV2(
            collectionName,
            record.id,
            record.question,
            planType
          )
        ).then(() => {
          dispatch(getTrainedDataV2(collectionName)).then(() => {
            dispatch(notify("success", "Deleted answer successfully"));
            setLoading(false);
          });
        });
      };

    const columns = [
        {
          title: "Question",
          dataIndex: "question",
          key: "question",
          render: (text) => <p className="tb-question">{text}</p>,
          width: "35%",
        },
        {
          title: "Old Answer",
          dataIndex: "answer",
          key: "answer",
          render: (text) => (
            <Space size="middle">
              <Button
                className="btn-bordered"
                type="outline"
                onClick={() => {
                  showModalOldAnswer(text);
                }}
              >
                View Answer
              </Button>
            </Space>
          ),
        },
        {
          title: "Updated Answer",
          dataIndex: "new_answer",
          key: "new_answer",
          render: (text) => (
            <Space size="middle">
              <Button
                className="btn-bordered"
                type="outline"
                onClick={() => {
                  showModalNewAnswer(text);
                }}
              >
                View Answer
              </Button>
            </Space>
          ),
        },
        {
          title: "Updated By",
          key: "updated_by",
          dataIndex: "updated_by",
          render: (text) => (
            <span key={text}>
              {text}
            </span>
          ),
        },
        {
          title: "Action",
          key: "id",
          render: (record) => (
            <>
            {!viewOnly ? 
            <Space size="middle" style={{ gap: "6px" }}>
              <Tooltip title="Edit Answer">
                <Button
                  type="primary"
                  shape="circle"
                  icon={<EditOutlined />}
                  onClick={() => showModalEditAnswer(record)}
                />
              </Tooltip>
              {isAdmin ?
              <Tooltip title="Delete">
                <Button
                  type="danger"
                  shape="circle"
                  icon={<DeleteOutlined />}
                  onClick={() => deleteUploadedAnswer(record)}
                />
              </Tooltip> : null}
            </Space>
            : null}
            </>
          ),
        },
    ];

    return(
        <>
      <div className="wk-trained">
        <Table columns={columns} dataSource={_trainedDataList}/>
      </div>
      <Modal
        className="table-modal"
        title="Edit Answer"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="modal-edit-qst">
          <TextArea
            value={editAnswerValue}
            onChange={(e) => setEditAnswerValue(e.target.value)}
            placeholder="Write Your Answer"
            autoSize={{ minRows: 3, maxRows: 8 }}
          />
        </div>
      </Modal>
      <Modal
        className="table-modal"
        title="Old Answer"
        open={isAnswerOld}
        onOk={handleOkOld}
        onCancel={handleCancelOld}
      >
        <p>{oldAnswerText}</p>
      </Modal>
      <Modal
        className="table-modal"
        title="Updated Answer"
        open={isAnswerNew}
        onOk={handleOkNew}
        onCancel={handleCancelNew}
      >
        <p>{newAnswerText}</p>
      </Modal>
        </>
    )
}
export default TrainedData;